<template>
  <section class="row">
    <div class="col-12 mb-1">
      <div class="h5 mb-1">
        L'essentiel en un coup d'oeil
      </div>
      <p>
        Retrouvez ici vos documents contractuels accessibles directement
      </p>
    </div>
    <div
      v-for="(card, index) in displayCards"
      :key="card.title"
      class="col-12 col-md-4 my-2"
      :class="card.class"
    >
      <router-link
        v-slot="{ navigate }"
        :to="`/client/${card.path}`"
        custom
      >
        <div
          class="card p-4 p-lg-2 p-xl-4 cursor-pointer h-100 text-center transition-shadow"
          :class="`box-shadow-${card.color}-500 box-shadow-hover-${card.color}-500`"
          @click="navigate"
        >
          <span
            v-for="i in 3"
            :key="i"
            class="pills-image"
            :class="[ `pill-card-${index + 1}-${i}` ]"
          />
          <div class="card-body d-flex flex-column justify-content-between">
            <h5 class="card-title">
              {{ card.title }}
            </h5>
            <p
              v-if="card.subtitle"
              class="h1 mx-auto"
            >
              {{ activeContracts }}
            </p>
            <v-icon
              folder="dashboard/svg/home"
              :icon="card.icon"
              width="100"
              height="70"
              class="mx-auto"
            />
          </div>
        </div>
      </router-link>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeDocuments',
  data() {
    return {
      displayCards: [
        {
          title: 'Vos dernières attestations',
          path: 'certificates',
          icon: 'contract-download',
          color: 'green',
          class: 'col-xl-6',
        },
        {
          title: 'Vos factures',
          path: 'invoices',
          icon: 'bills',
          color: 'blue',
          class: 'col-xl-3',
        },
        {
          title: 'Contrats actifs',
          subtitle: true,
          path: 'contracts',
          icon: 'shield',
          color: 'pink',
          class: 'col-xl-3',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
    }),
    activeContracts() {
      return (this.contracts
        .filter(({ status, parentId }) => status === 'ACTIVE' && !parentId) || [])
        .length;
    },
  },
};
</script>
<style scoped>
.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-300);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-300);
}
.pill-card-1-3 {
  bottom: 14%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-2-1 {
  top: 37%;
  right: 20px;
  width: 48px;
  background-color: var(--bs-blue-300);
}
.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-300);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-300);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-300);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-300);
}
</style>
